const initialState = {
    bool: false
}

const experienceInputsErrRed = (state = initialState, action) => {
    switch(action.type){
        case 'EXPERIENCE_INPUTS_ERR' : {
            return {
                ...state,
                bool: action.bool
            }
        }
        default: {
            return state
        }
    }
}

export default experienceInputsErrRed